import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CountryMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.country.countryMapperError"));

        Object.setPrototypeOf(this, CountryMapperError.prototype);
    }
}